import React, { useState, useRef, useEffect } from "react";
import { Input, Select, SideSVG } from "../../../common";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as CompanyInfo } from "../../../../assets/images/signUp/companyInfo.svg";
import { useSelector } from "react-redux";
import Logo from "../../Logo";
import { ReactComponent as EmailIcon } from "../../../../assets/icons/email.svg";
import { useCreateAddressDetailsUpdateMutation, useGetCompanyClaimedMutation } from "../../../../store/Company/companyApiSlice";
import { handleKeyPress, validateEmail } from "../../../../utils/Helper";
import { useDispatch } from "react-redux";

import { extractCountryCodeAndPhoneCode } from "../../../../utils/countriesState";
import { setClaimContactDetails, setClearClaimDetails } from "../../../../store/claim/claimSlice";
import { useNavigate } from "react-router-dom";
import { CommonToast } from "../../../common/Toast";
import { clearUserInfo } from "../../../../store/auth/authSlice";
import { useGetUserQuery } from "../../../../store/auth/usersApiSlice";
import PhoneNumberInput from "../../../common/PhoneNumberInput";
import { isPossiblePhoneNumber } from 'react-phone-number-input';

export const ContactInformation = ({ onNext, onPrev }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const emailRef = useRef();
  // const companyTelPhoneRef = useRef();
  const [mobile, setMobile] = useState("");
  const [errors, setErrors] = useState({});
  const [countryCode, setCountryCode] = useState("+971");
  const [countryCodes, setCountryCodes] = useState(extractCountryCodeAndPhoneCode());
  const [apiError, setApiError] = useState("");
  const [apiLoading, setApiLoading] = useState(false);
  const { filledCompany, claimAuthSignDetails, claimTradeLicenseDetails, industryDetails, claimAddressDetails } = useSelector((state) => state.claims);
  const { companyAddress } = useSelector((state) => state.company);
  const { token, userInfo } = useSelector((state) => state.auth);
  const [getCompanyClaimed, { isLoading: GetCompanyClaimedLoading }] = useGetCompanyClaimedMutation();
  const { refetch } = useGetUserQuery(token);

  const [addressDetailsUpdate, { isLoading }] =
    useCreateAddressDetailsUpdateMutation();

  useEffect(() => {
    if (companyAddress) {
      emailRef.current.value = companyAddress?.email;
      setMobile(companyAddress?.telephone || "");
      setCountryCode(companyAddress?.telephone?.split("|")[0] || "+971");
    }
  }, [companyAddress]);

  const companyDataString = localStorage.getItem("createCompany");
  const companyData = JSON.parse(JSON.stringify(companyDataString));
  let claimComapnyID = localStorage.getItem("claimComapnyID");
  const createCompanyID = companyData?.companyID;
  const companyDataCurrent = localStorage.getItem("companyData");
  const companyCurrentData = JSON.parse(companyDataCurrent);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiLoading(true)
    const errors = {};
    if (emailRef?.current?.value?.trim() === "") {
      errors.emailError = "Company mail is required.";
      setApiLoading(false)
    }

    const checkEmail = validateEmail(emailRef?.current?.value?.trim());
    if (!checkEmail) {
      errors.emailError = "Please enter a valid email";
      setApiLoading(false)
    }

    if (mobile?.trim() === "") {
      errors.companyTel = "Telephone number is required.";
      setApiLoading(false)
    }
    if (!isPossiblePhoneNumber(mobile?.toString() ?? "")) {
      errors.companyTel = "Enter valid mobile number";
    }
    setErrors(errors);
    if (!token) {
      CommonToast.error("Token is required");
      dispatch(clearUserInfo());
      navigate('/login');
      throw new Error("Token is required")
    }

    if (Object.keys(errors).length === 0) {
      const telephone = mobile;
      let userSelectedCompany = JSON.parse(localStorage.getItem("userSelectedCompany"));
      let claimContactDetails = {
        telephone: telephone,
        email: emailRef.current.value,
      };
      try {
        const claimedCompanyResposne = await getCompanyClaimed({
          data: {
            companyID: filledCompany?.new_company ? "NEW_COMPANY" : filledCompany ? (filledCompany?.companyID || filledCompany?.wb_win) : (userSelectedCompany?.companyID || userSelectedCompany?.data?.companyID || userSelectedCompany?.data?.wb_win || userSelectedCompany?.wb_win),
            registered_company_name: filledCompany ? filledCompany.registered_company_name : (userSelectedCompany?.data?.registered_company_name || userSelectedCompany?.registered_company_name),
            country_code: filledCompany ? filledCompany?.country_code : (userSelectedCompany?.data?.country_code || userSelectedCompany?.country_code),
            trade_license: claimTradeLicenseDetails.trade_license,
            license_no: claimTradeLicenseDetails.license_no,
            // industry_sector: industryDetails.sector,
            // industry_industry_group: industryDetails.industry_group,
            // industry_industry: industryDetails.industry,
            sub_industry: industryDetails,
            // auth_sign_name: claimAuthSignDetails.name,
            // auth_sign_designation: claimAuthSignDetails.designation,
            // auth_sign_work_email: claimAuthSignDetails.work_email,
            // auth_sign_work_mobile: claimAuthSignDetails.work_mobile,
            // auth_sign_nationality: claimAuthSignDetails.nationality,
            // auth_sign_authorized_signatory: claimAuthSignDetails.authorized_signatory,
            address_address_line_1: claimAddressDetails.address_line_1,
            address_city: claimAddressDetails.city,
            address_state: claimAddressDetails.state,
            address_country: claimAddressDetails.country,
            address_working_hours: claimAddressDetails.working_hours,
            address_telephone: claimContactDetails.telephone,
            address_email: claimContactDetails.email,
            address_address_line_2: claimAddressDetails.address_line_2,
            address_postal_code: claimAddressDetails.postal_code,
            address_area: claimAddressDetails.area,
            registration_body: claimTradeLicenseDetails.selectedRegistrationBody.value,
          },
          token,
        });
        if (claimedCompanyResposne?.data?.companyID) {
          dispatch(setClearClaimDetails())
          localStorage.removeItem("userSelectedCompany");
          setTimeout(() => {
            refetch();
            onNext(createCompanyID || claimComapnyID, companyData
              ? companyData?.new_company
              : companyCurrentData?.new_company);
          }, 200);
        }
        setApiLoading(false)
      } catch (error) {
        if (error.status === 401) {
          setApiError("You are not authorized to access this page.");
        } else {
          setApiError(
            error?.data
              ? Object.values(error?.data)[0]
              : "An error occurred. Please try again later."
          );
        }
        setApiLoading(false)
      }
    } 
    // else if (!claimAuthSignDetails.authorized_signatory) {
    //   CommonToast.error('You are not authorized Signatory')
    // }
  };

  return (
    <section className="relative px-4 sm:px-0 py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex -mx-4 xl:items-center items-center max-h-screen">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md py-20 mx-auto ">
                <h3 className="font-heading text-f24 sm:text-f30 text-primary font-bold mb-4 text-center punitpunit">
                  Company Contact Information
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-6">
                    <div className="flex items-start flex-col mb-6">
                      <label className="text-primary text-f14 font-semibold">
                        Email Address
                      </label>
                      <div className="relative w-full">
                        <input
                          type="email"
                          className="w-full py-2 pl-10 border border-input rounded bg-inputDisable focus:outline-none outline-none"
                          placeholder="Enter your company email address"
                          ref={emailRef}
                        />
                        <div className="absolute top-3 left-3">
                          <EmailIcon />
                        </div>
                      </div>
                      {errors.emailError && (
                        <p className="text-red-500 text-sm text-left">
                          {errors.emailError}
                        </p>
                      )}
                      {apiError && apiError?.[0].includes("email") && (
                        <p className="text-red-500 text-sm text-left">
                          {apiError}
                        </p>
                      )}
                    </div>
                    <div className="flex items-start flex-col mb-6">
                      <div className="flex items-start flex-col mb-0 w-full">
                        <label className="text-primary text-f14 font-semibold">
                          Contact No.
                        </label>
                        <div className="relative w-full">
                          <PhoneNumberInput
                            id="mobile"
                            phone={mobile}
                            border={true}
                            setPhone={setMobile}
                            verifyPhoneNumber={false}
                            classes={'addBackground'}
                            error={""} />
                        </div>
                        {errors.companyTel && (
                          <p className="text-red-500 text-sm text-left">
                            {errors.companyTel}
                          </p>
                        )}
                      </div>
                      {apiError && !apiError?.[0].includes("email") && (
                        <p className="text-red-500 text-sm text-left">
                          {apiError}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-between gap-2">
                    <button
                      type="button"
                      className="inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full"

                    >
                      <ArrowLeft onClick={(e) => {
                        e.preventDefault();
                        onPrev();
                      }} />
                      <span className="relative" onClick={(e) => {
                        e.preventDefault();
                        onPrev();
                      }}>Go Back</span>
                    </button>
                    <button
                      className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 ${apiLoading ? "cursor-not-allowed bg-disable" : "cursor-pointer bg-primary"}`}
                      onClick={handleSubmit}
                      disabled={apiLoading}
                    >
                      <span className="relative">
                        {isLoading || apiLoading ? <Spinner /> : "Save & Continue"}
                      </span>
                      <ArrowRight />
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <SideSVG
              SVG={CompanyInfo}
              positions="top-80 transform -translate-y-1/2 left-[-25%]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
